import styled, { css } from 'styled-components/macro';

import { FlexDirectionType } from 'common/types/flex';

export const Grid = styled.div<{
  $columns: number;
  $gap?: number | string;
  $verticalGap?: number | string;
}>`
  display: grid;
  grid-template-columns: repeat(${({ $columns }) => $columns}, minmax(0, 1fr));
  gap: ${({ $verticalGap }) => ($verticalGap !== undefined ? $verticalGap : 0)}
    ${({ theme, $gap }) => ($gap !== undefined ? $gap : theme.spacing.one_2)};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(calc(${({ $columns }) => $columns} / 2), minmax(0, 1fr));
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: repeat(calc(${({ $columns }) => $columns} / 4), minmax(0, 1fr));
  }
`;

export const Flex = styled.div<{
  $gap?: number | string;
  $columns?: number;
  $direction?: FlexDirectionType;
  $stretch?: boolean;
}>`
  --gap: ${({ theme, $gap }) => ($gap !== undefined ? $gap : theme.spacing.one_2)};
  /* set column to default 1 if value is less then 1 or is not set */
  --columns: ${({ $columns }) => $columns ?? 1};
  display: flex;
  flex-flow: ${({ $direction }) => (!!$direction ? $direction : 'row')} wrap;
  align-items: stretch;
  justify-content: flex-start;
  gap: var(--gap);

  & > * {
    ${({ $direction }) =>
      $direction === 'row'
        ? css<{ $columns?: number }>`
            --gap-correction: ((var(--gap) * (var(--columns) - 1)) / var(--columns));
            flex: 0 0 calc(((100 / var(--columns)) * 1%) - var(--gap-correction));

            @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
              --columns: max(1, ${({ $columns }) => Math.round(($columns ?? 1) / 2)});
            }

            @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
              --columns: max(1, ${({ $columns }) => Math.round(($columns ?? 1) / 4)});
            }
          `
        : css`
            display: flex;
            align-items: stretch;
            justify-content: space-between;
            flex-flow: row nowrap;
            gap: var(--gap);

            & > * {
              flex: 1 1 auto;
            }
          `}
  }

  ${({ theme, $stretch }) =>
    $stretch &&
    css`
      & > div {
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing.one};
        padding: ${theme.spacing.one} 0;
      }

      & > div > * {
        margin-top: 0;
        margin-bottom: 0;
      }
    `}
`;
